'use client';

import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useCallback } from 'react';

declare global {
  interface Window {
    gtag: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
    dataLayer: any[];
  }
}

export function useAnalytics(gaId: string) {
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search;
  const previousPathname = useRef<string>('');

  // Track page views when route changes
  useEffect(() => {
    if (typeof window === 'undefined' || !window.gtag) return;

    const url = pathname + search;

    // Avoid duplicate page view for the same path
    if (previousPathname.current === url) return;
    previousPathname.current = url;

    // Small delay to ensure document.title is updated by Next.js metadata
    const timer = setTimeout(() => {
      window.gtag('event', 'page_view', {
        page_path: url,
        page_title: document.title,
        page_location: window.location.href,
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname, search, gaId]);

  // Custom event tracking helper
  const trackEvent = useCallback(
    (eventName: string, parameters?: Record<string, any>) => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, parameters);
      }
    },
    []
  );

  return { trackEvent };
}
